import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const GripIcon = ({ height, viewBox, width }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox}>
            <path
                fill={MIGRATED_COLORS.tan}
                stroke={MIGRATED_COLORS.grey32}
                d="M0.5 0.5H12.5V26.5H0.5z"
            />
            <path
                fill={MIGRATED_COLORS.literalD8D8D8}
                stroke={MIGRATED_COLORS.black2}
                d="M4.5 6.5H5.5V20.5H4.5zM8.5 6.5H9.5V20.5H8.5z"
            />
        </SvgIcon>
    );
};

GripIcon.propTypes = {
    height: string,
    viewBox: string,
    width: string,
};

GripIcon.defaultProps = {
    height: '30',
    viewBox: '0 0 20 30',
    width: '20',
};

export default GripIcon;
